import { Injectable, Inject } from '@angular/core';
import { HttpParams, HttpClient } from '@angular/common/http';
import { IUploadFilesCommand, IUploadFileCommandResult, IContextQueryResult, IListItemQueryResult, ICreateDirectoryCommand } from '../models/interface';
import { FileManagerConfig } from '../FileManagerConfig';

@Injectable()
export class FileManagerService {

  constructor(@Inject('config') private config: FileManagerConfig, private http: HttpClient) 
  { 

  }



  get host() {
    const ret = this.config.origin();
    return ret;
  }

  // temporary
  apiUrl(route: string) {
    if (!this.host) {
      throw "host origin hasn't been set.";
    }

    return `${this.host}/${route}`;
  }

  uploadFiles(context: IUploadFilesCommand, files: File[]) {
    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append('file', files[i]);
    }

    let params = new HttpParams();
    params = params.append('contextName', context.contextName);
    if (context.directoryId)
      params = params.append('directoryId', context.directoryId);

    return this.http.post<IUploadFileCommandResult[]>(this.apiUrl(`api/command/UploadFiles`), formData, {
      params: params
    });
  }

  findFileById(id: string) {
    return this.http.post<IListItemQueryResult>(this.apiUrl(`api/query/FindFileById`), {
      id: id
    });
  }

  deleteFile(id: string) {
    return this.http.post<string>(this.apiUrl(`api/command/DeleteFile`), {
      id: id
    });
  }

  deleteDirectory(id: string) {
    return this.http.post<string>(this.apiUrl('api/command/DeleteDirectory'), {
      id: id
    });
  }

  createDirectory(command: ICreateDirectoryCommand) {
    return this.http.post<string>(this.apiUrl(`api/command/CreateDirectory`), command);
  }

  findContextByName(name: string) {
    return this.http.post<IContextQueryResult>(this.apiUrl(`api/query/FindContextByName`), {
      name: name
    });
  }

  getAllContexts() {
    return this.http.post<IContextQueryResult[]>(this.apiUrl(`api/query/GetAllContexts`), {});
  }

  getItemsOfContext(contextName: string) {
    return this.http.post<IListItemQueryResult[]>(this.apiUrl(`api/query/ListItemOfContext`), {
      contextName: contextName
    })
  }

  getItemsOfDirectory(directoryId: string) {
    return this.http.post<IListItemQueryResult[]>(this.apiUrl(`api/query/ListItemOfDirectory`), {
      directoryId: directoryId
    });
  }
}